// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

































































































/* Horizontal auto margins only: \`margin: auto\` also sets the block margins,
   which suppresses the flex cross-axis stretch and leaves height: 100% as the
   only source of height. Every page inside the frame is absolutely positioned,
   so the moment that percentage resolves to auto the frame collapses to zero and
   the camera, the spinner and the controls all end up stacked at the top of the
   screen. Stretching keeps the height even then. */
.ui-camera-frame[data-v-1550d8e7] {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  position: relative;
  overflow: auto;
}
.content-panel[data-v-1550d8e7] {
  display: flex;
  width: 100%;
  padding-top: 62.5%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity var(--frame-time) ease-in-out;
}
.no-camera .content-panel[data-v-1550d8e7] {
  opacity: 0;
}
.camera-panel[data-v-1550d8e7] {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.camera-title[data-v-1550d8e7] {
  line-height: 2rem;
  z-index: 2;
  position: absolute;
  text-align: center;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
}
.details-panel[data-v-1550d8e7] {
  position: absolute;
  width: 100%;
  padding: 2rem;
  overflow: auto;
  display: flex;
}
@media screen and (min-height: 41rem) {
.details-panel[data-v-1550d8e7] {
    height: 100%;
}
}
@media screen and (max-width: 30rem) {
.details-panel[data-v-1550d8e7] {
    height: 100%;
}
}
.hide-active-controls .details-panel[data-v-1550d8e7],
.bottom-controls .details-panel[data-v-1550d8e7] {
  pointer-events: none;
}
.details-content[data-v-1550d8e7] {
  background-color: var(--white);
  width: 100%;
  max-width: 20rem;
  max-height: max-content;
  margin: auto;
  padding: 2rem;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  pointer-events: all;
  z-index: 1;
}
.no-camera .details-content[data-v-1550d8e7] {
  max-height: 0;
  opacity: 0;
}

/* \`margin: auto\` only centres horizontally in block flow, so anchoring this at
   top: 50% put the spinner's top edge on the midpoint at best. Fixed rather than
   absolute so the "starting camera" spinner centres on the page the user is
   looking at instead of on the frame's own box, which is the one thing on this
   screen that has no content of its own to give it a height. */
.loader-wrapper[data-v-1550d8e7] {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hide-active-controls .details-content[data-v-1550d8e7] {
  max-height: 0;
  opacity: 0;
}
.bottom-controls .details-content[data-v-1550d8e7] {
  padding: 1rem 2rem;
  background-color: transparent;
  box-shadow: none;
}
.description-panel[data-v-1550d8e7] {
  max-height: 25rem;
  overflow: hidden;
}
.bottom-controls .description-panel[data-v-1550d8e7] {
  max-height: 0;
  opacity: 0;
  transform: translateY(-0.5rem);
}
.review-photo .details-content[data-v-1550d8e7] {
  max-width: 40rem;
  width: 100%;
}
.mobile-app .ui-camera-frame[data-v-1550d8e7],
.mobile-app .content-panel[data-v-1550d8e7] {
  height: 100%;
}
.mobile-app .bottom-controls .details-content[data-v-1550d8e7] {
  margin-bottom: 0;
}
.desktop-app .ui-camera-frame[data-v-1550d8e7] {
  max-width: 60rem;
}
.desktop-app .bottom-controls .details-content[data-v-1550d8e7] {
  padding-top: 60%;
}
@media screen and (max-width: 48em) {
.mobile-app .camera-title[data-v-1550d8e7] {
    padding: 6rem 1rem 1rem;
    width: 100%;
    position: absolute;
    font-size: 1.3rem;
    line-height: 1.3rem;
}
}
@media screen and (max-height: 40rem) and (min-width: 48rem) {
.mobile-app .camera-panel[data-v-1550d8e7] {
    height: 70%;
    top: 50%;
    transform: translateY(-50%);
}
}
@media screen and (max-height: 50rem) and (min-width: 48rem) {
.mobile-app .camera-title[data-v-1550d8e7] {
    width: 55%;
    top: -1rem;
}
}
@media screen and (max-height: 50rem) {
.desktop-app .camera-title[data-v-1550d8e7] {
    width: 50%;
}
}
@media screen and (max-width: 48em) {
.desktop-app .camera-title[data-v-1550d8e7] {
    transform: translate(-50%, calc(-100% - 2rem));
    padding-inline: 1rem;
}
.desktop-app .bottom-controls .details-content[data-v-1550d8e7] {
    transform: translateY(3rem);
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/UiCameraFrame.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAkGA;;;;;mDAKA;AACA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AACA;AAEA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iDAAA;AACA;AAEA;EACA,UAAA;AACA;AAEA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACA;AAEA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,0BAAA;EACA,WAAA;AACA;AAEA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AACA;AAEA;AACA;IACA,YAAA;AACA;AACA;AAEA;AACA;IACA,YAAA;AACA;AACA;AAEA;;EAEA,oBAAA;AACA;AAEA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,uCAAA;EACA,mBAAA;EACA,UAAA;AACA;AAEA;EACA,aAAA;EACA,UAAA;AACA;;AAEA;;;;+DAIA;AACA;EACA,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACA;AAEA;EACA,aAAA;EACA,UAAA;AACA;AAEA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AACA;AAEA;EACA,iBAAA;EACA,gBAAA;AACA;AAEA;EACA,aAAA;EACA,UAAA;EACA,8BAAA;AACA;AAEA;EACA,gBAAA;EACA,WAAA;AACA;AAEA;;EAEA,YAAA;AACA;AAEA;EACA,gBAAA;AACA;AAEA;EACA,gBAAA;AACA;AAEA;EACA,gBAAA;AACA;AAEA;AACA;IACA,uBAAA;IACA,WAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;AACA;AACA;AAEA;AACA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;AACA;AACA;AAEA;AACA;IACA,UAAA;IACA,UAAA;AACA;AACA;AACA;AACA;IACA,UAAA;AACA;AACA;AAEA;AACA;IACA,8CAAA;IACA,oBAAA;AACA;AAEA;IACA,2BAAA;AACA;AACA","sourcesContent":["<template>\n  <div\n    class=\"ui-camera-frame\"\n    :class=\"[\n      controlStyle,\n      controlsPosition,\n      { 'no-camera': !isCameraLoaded, 'review-photo': !!file }\n    ]\"\n  >\n    <div class=\"content-panel\">\n      <div class=\"camera-panel\">\n        <h2 v-if=\"title && isCameraActive\" class=\"camera-title\">\n          {{ title }}\n        </h2>\n        <slot name=\"camera\" />\n      </div>\n    </div>\n    <page-logo />\n    <div v-if=\"isCameraLoaded\" class=\"details-panel\">\n      <div class=\"details-content\">\n        <div class=\"description-panel\">\n          <slot name=\"description\" />\n        </div>\n        <photo-review v-if=\"file\" :photo=\"file\" :thumbnail=\"fileThumbnail\" />\n        <slot name=\"controls\" />\n      </div>\n    </div>\n    <div v-else class=\"loader-wrapper\"><ui-loader center :size=\"3\" /></div>\n  </div>\n</template>\n\n<script>\nimport PageLogo from '@src/components/partials/PageLogo'\nimport PhotoReview from '@src/components/partials/PhotoReview'\nimport getters from '@src/store/getters'\nimport { mapGetters } from 'vuex'\nimport { appPages } from '@src/scripts/enums'\nimport { activityLogger } from '@src/scripts/activityLogger'\n\nexport default {\n  name: 'ui-camera-frame',\n\n  components: {\n    PageLogo,\n    PhotoReview\n  },\n\n  props: {\n    file: { type: Blob, default: undefined },\n    fileThumbnail: { type: String, default: undefined },\n    title: { type: String, default: undefined },\n    resource: { type: String, default: undefined },\n    activeControls: Boolean\n  },\n\n  data() {\n    return {\n      reviewPhoto: null\n    }\n  },\n\n  computed: {\n    ...mapGetters([\n      getters.isCameraLoaded,\n      getters.isCameraActive,\n      getters.isCameraLoading\n    ]),\n\n    controlStyle() {\n      const { isCameraActive, isCameraLoading, activeControls } = this\n\n      if (isCameraLoading || (isCameraActive && !activeControls)) {\n        return 'hide-active-controls'\n      }\n      return null\n    },\n\n    controlsPosition() {\n      const { isCameraActive, isCameraLoading, activeControls } = this\n\n      if (activeControls && (isCameraActive || isCameraLoading)) {\n        return 'bottom-controls'\n      }\n      return null\n    }\n  },\n\n  watch: {\n    isCameraLoaded(newVal) {\n      if (newVal && this.resource === appPages.face) {\n        activityLogger.logActivity('IDENTIFY_FACE_PAGE_RENDERED')\n      }\n    }\n  }\n}\n</script>\n\n<style scoped>\n/* Horizontal auto margins only: `margin: auto` also sets the block margins,\n   which suppresses the flex cross-axis stretch and leaves height: 100% as the\n   only source of height. Every page inside the frame is absolutely positioned,\n   so the moment that percentage resolves to auto the frame collapses to zero and\n   the camera, the spinner and the controls all end up stacked at the top of the\n   screen. Stretching keeps the height even then. */\n.ui-camera-frame {\n  width: 100%;\n  margin: 0 auto;\n  height: 100%;\n  position: relative;\n  overflow: auto;\n}\n\n.content-panel {\n  display: flex;\n  width: 100%;\n  padding-top: 62.5%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  transition: opacity var(--frame-time) ease-in-out;\n}\n\n.no-camera .content-panel {\n  opacity: 0;\n}\n\n.camera-panel {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.camera-title {\n  line-height: 2rem;\n  z-index: 2;\n  position: absolute;\n  text-align: center;\n  left: 50%;\n  transform: translate(-50%);\n  width: 100%;\n}\n\n.details-panel {\n  position: absolute;\n  width: 100%;\n  padding: 2rem;\n  overflow: auto;\n  display: flex;\n}\n\n@media screen and (min-height: 41rem) {\n  .details-panel {\n    height: 100%;\n  }\n}\n\n@media screen and (max-width: 30rem) {\n  .details-panel {\n    height: 100%;\n  }\n}\n\n.hide-active-controls .details-panel,\n.bottom-controls .details-panel {\n  pointer-events: none;\n}\n\n.details-content {\n  background-color: var(--white);\n  width: 100%;\n  max-width: 20rem;\n  max-height: max-content;\n  margin: auto;\n  padding: 2rem;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);\n  pointer-events: all;\n  z-index: 1;\n}\n\n.no-camera .details-content {\n  max-height: 0;\n  opacity: 0;\n}\n\n/* `margin: auto` only centres horizontally in block flow, so anchoring this at\n   top: 50% put the spinner's top edge on the midpoint at best. Fixed rather than\n   absolute so the \"starting camera\" spinner centres on the page the user is\n   looking at instead of on the frame's own box, which is the one thing on this\n   screen that has no content of its own to give it a height. */\n.loader-wrapper {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hide-active-controls .details-content {\n  max-height: 0;\n  opacity: 0;\n}\n\n.bottom-controls .details-content {\n  padding: 1rem 2rem;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.description-panel {\n  max-height: 25rem;\n  overflow: hidden;\n}\n\n.bottom-controls .description-panel {\n  max-height: 0;\n  opacity: 0;\n  transform: translateY(-0.5rem);\n}\n\n.review-photo .details-content {\n  max-width: 40rem;\n  width: 100%;\n}\n\n.mobile-app .ui-camera-frame,\n.mobile-app .content-panel {\n  height: 100%;\n}\n\n.mobile-app .bottom-controls .details-content {\n  margin-bottom: 0;\n}\n\n.desktop-app .ui-camera-frame {\n  max-width: 60rem;\n}\n\n.desktop-app .bottom-controls .details-content {\n  padding-top: 60%;\n}\n\n@media screen and (max-width: 48em) {\n  .mobile-app .camera-title {\n    padding: 6rem 1rem 1rem;\n    width: 100%;\n    position: absolute;\n    font-size: 1.3rem;\n    line-height: 1.3rem;\n  }\n}\n\n@media screen and (max-height: 40rem) and (min-width: 48rem) {\n  .mobile-app .camera-panel {\n    height: 70%;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n\n@media screen and (max-height: 50rem) and (min-width: 48rem) {\n  .mobile-app .camera-title {\n    width: 55%;\n    top: -1rem;\n  }\n}\n@media screen and (max-height: 50rem) {\n  .desktop-app .camera-title {\n    width: 50%;\n  }\n}\n\n@media screen and (max-width: 48em) {\n  .desktop-app .camera-title {\n    transform: translate(-50%, calc(-100% - 2rem));\n    padding-inline: 1rem;\n  }\n\n  .desktop-app .bottom-controls .details-content {\n    transform: translateY(3rem);\n  }\n}\n</style>\n\n<style>\n.review-photo .instructions-container {\n  max-width: 18rem;\n  margin: auto;\n}\n\n.desktop-app .review-photo .controls-group.main-controls {\n  justify-content: space-evenly;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
